import * as React from "react"
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils"

const badgeVariants = cva(
  "inline-flex items-center rounded-full px-3 py-1 text-xs font-semibold transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default:
          "border-primary/30 bg-gradient-to-br from-primary/15 to-primary/10 text-primary backdrop-blur-md shadow-sm hover:shadow-md hover:scale-105",
        secondary:
          "border-slate-300 bg-slate-100 text-slate-700 hover:bg-slate-200 hover:scale-105",
        destructive:
          "border-destructive/30 bg-gradient-to-br from-destructive/15 to-destructive/10 text-destructive backdrop-blur-md shadow-sm hover:shadow-md hover:scale-105",
        outline: "text-slate-700 border-slate-300 bg-white/80 backdrop-blur-md hover:border-primary/30 hover:bg-primary/5",
        success:
          "border-emerald-300 bg-emerald-100 text-emerald-700 hover:bg-emerald-200",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

function Badge({
  className,
  variant,
  ...props
}) {
  return (<span className={cn(badgeVariants({ variant }), className)} {...props} />);
}

export { Badge, badgeVariants }
